<template>
	<div class="home_title_item">
		<h3 class="title">{{ title }}</h3>
		<p class="sub">{{ sub }}</p>
	</div>
</template>

<script>
export default {
	name: "index",
	props: {
		title: {
			type: String,
			default: ""
		},

		sub: {
			type: String,
			default: ""
		}
	}
}
</script>

<style lang="less" scoped>
.home_title_item {
	text-align: center;
	line-height: 1;
	margin: 55px 0 35px;

	.title {
		font-size: 30px;
		color: @blackLine;
		font-weight: bold;
	}

	.sub {
		font-size: 24px;
		color: @red;
		font-weight: bold;
		margin-top: 16px;
	}
}
</style>
